<template>
  <div class="PaymentPage">
    <div class="container flex-center">
      <app-loading />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { extractErrorMessage } from '@/utilities/common'

  export default {
    name: 'payment-result',

    mounted () {
      const urlOrigin = window.location.origin
      const query = this.$route.query
      const queryString = window.location.search.substring(1)
      let cultureCode = ''
       if ((query.shopperLocale && query.shopperLocale.replace('_', '-').toLowerCase() === 'en-ca') || (query.shopperLocale && query.shopperLocale.replace('_', '-').toLowerCase() === 'fr-ca')) {
        cultureCode = 'en-ca'
       } else if ((query.shopperLocale && query.shopperLocale.replace('_', '-').toLowerCase() === 'nl-be') || (query.shopperLocale && query.shopperLocale.replace('_', '-').toLowerCase() === 'fr-be')) {
        cultureCode = 'nl-be'       
       } else {
        cultureCode = query.shopperLocale && query.shopperLocale.replace('_', '-').toLowerCase()
      } 
 
      const handlePaymentCallback = function (createdReason, isPaymentSuccess, subscriptionNumber) {
        switch (createdReason) {
          case 'Init':
            if (isPaymentSuccess) {
              window.location.href = `${urlOrigin}/${cultureCode}/subscription-successful`
            } else {
              window.location.href = `${urlOrigin}/${cultureCode}/subscription-error`
            }
            break

          case 'Change':
            if (isPaymentSuccess) {
              Vue.prototype.$notify({
                type: 'success',
                title: Vue.prototype.$t('popuptips.paymentMethod.update.successful', 'update payment method successfully, new payment method info will updated to account in few minutes'),
                duration: 5000
              })
            } else {
              Vue.prototype.$notify({
                type: 'error',
                title: Vue.prototype.$t('popuptips.paymentMethod.update.failed', 'failed to update payment method'),
                duration: 5000
              })
            }
            setTimeout(() => {
              window.location.href = `${urlOrigin}/${cultureCode}/my-account/payment-details`
            }, 3000)
            break

          case 'ChangeAndPayInFull':
            if (isPaymentSuccess) {
              window.location.href = `${urlOrigin}/${cultureCode}/my-account/subscription-thankyou/${subscriptionNumber}`
            } else {
              window.localStorage.setItem('changePaymentAndPayInfullResult', 'failed')
              window.location.href = `${urlOrigin}/${cultureCode}/my-account/subscription-details/${subscriptionNumber}`
            }
            break

          case 'ChangeAndImmediatePayment':
            if (isPaymentSuccess) {
              Vue.prototype.$notify({
                type: 'success',
                title: Vue.prototype.$t('popuptips.paymentMethod.payNow.successful', 'Your payment past due paided successfully'),
                duration: 5000
              })
              window.location.href = `${urlOrigin}/${cultureCode}/pay-now-successful`
            } else {
              Vue.prototype.$notify({
                type: 'error',
                title: Vue.prototype.$t('popuptips.paymentMethod.payNow.failed', 'Your payment past due paided failed'),
                duration: 5000
              })
              window.location.href = `${urlOrigin}/${cultureCode}/subscription-error`
            }
            break
        }
      }

      Vue.api.payment.paymentResult(queryString).then(data => {
        handlePaymentCallback(data.createdReason, data.isPaymentSuccess, data.subscriptionNumber)
      }).catch((error) => {
        this.$notify({
          type: 'error',
          title: extractErrorMessage(error)
        })
      })
    }
  }
</script>

<style lang="scss">
  .PaymentPage {
    .container {
      min-height: 6rem;
    }
  }
</style>
